import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const CTASection = () => {
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-br from-primary/10 via-accent/5 to-background">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Main CTA Content */}
          <div className="space-y-6">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-text-primary leading-tight">
              Ready to Transform Your
              <span className="block text-primary">Prompt Creation?</span>
            </h2>
            <p className="text-xl md:text-2xl text-text-secondary max-w-3xl mx-auto leading-relaxed">
              Join thousands of professionals who are already using AI to create better prompts faster. Start your journey today.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Link to="/prompt-generator">
              <Button 
                variant="default" 
                size="xl" 
                iconName="Rocket" 
                iconPosition="left"
                className="px-10 py-5 text-lg font-semibold hover-scale"
              >
                Get Started Free
              </Button>
            </Link>
            <Link to="/pricing-plans">
              <Button 
                variant="outline" 
                size="xl" 
                iconName="Eye" 
                iconPosition="left"
                className="px-10 py-5 text-lg font-medium"
              >
                View All Plans
              </Button>
            </Link>
          </div>

          {/* Additional Benefits */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 pt-12 text-sm text-text-secondary">
            <div className="flex items-center space-x-2">
              <Icon name="CheckCircle" size={16} color="var(--color-success)" />
              <span>No credit card required</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} color="var(--color-warning)" />
              <span>Setup in under 2 minutes</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Shield" size={16} color="var(--color-primary)" />
              <span>Cancel anytime</span>
            </div>
          </div>

          {/* Demo Request */}
          <div className="pt-12 border-t border-border/50">
            <p className="text-text-secondary mb-4">
              Need a custom demo for your team?
            </p>
            <Button 
              variant="ghost" 
              iconName="Calendar" 
              iconPosition="left"
              className="text-primary hover:text-primary"
            >
              Schedule a Demo
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;